import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductInventory extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newInventory = event.detail.data.html.querySelector('product-inventory');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
    this.#replaceDelayNotice(newInventory);
  };

  /**
   * Keep the Spark-safe sibling in sync when the selected variant changes.
   * @param {Element} newInventory
   */
  #replaceDelayNotice(newInventory) {
    const wrap = this.parentElement;
    if (!wrap?.classList.contains('product-inventory-wrap')) return;

    const incomingNotice = newInventory.parentElement?.querySelector(':scope > .product-inventory__delay-notice');
    const currentNotice = wrap.querySelector(':scope > .product-inventory__delay-notice');

    if (incomingNotice && currentNotice) {
      currentNotice.replaceWith(incomingNotice.cloneNode(true));
    } else if (incomingNotice && !currentNotice) {
      wrap.appendChild(incomingNotice.cloneNode(true));
    } else if (!incomingNotice && currentNotice) {
      currentNotice.remove();
    }
  }
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
